// @flow
import React from 'react';
import SMUserResource from 'resources/SMUserResource';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import OptimizedImage from 'components/shared/OptimizedImage';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import {Textfield} from 'react-mdl';
import SMOptionalServiceResource from 'resources/SMOptionalServiceResource.js';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';

type Props = {
  currentUser: Object,
  optionalService: Object,
  noFavoriteListImage: string
};

type State = {
  mailUrl: string,
  fbUrl: string,
  lineUrl: string,
  rooms: Array<Object>,
  canRequest: boolean,
  errors: Object,
  isSMUFavoriteListSelectViewOpen: boolean,
  latestUpdatedFavoriteList: Object,
  targetFavoriteRoom: Object,
  isOpenDefaultFavoriteList: boolean
};


class SMOptionalServiceView extends React.Component {
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      mailUrl: '#',
      fbUrl: '#',
      lineUrl: '#',
      rooms: this.props.optionalService.rooms,
      canRequest: true,
      errors: {},
      isSMUFavoriteListSelectViewOpen: false,
      isOpenDefaultFavoriteList: false,
      latestUpdatedFavoriteList: {},
      targetFavoriteRoom: {},
    };
  }

  componentDidMount() {
    setTimeout(this.setSocialLinks.bind(this), 10);
  }

  trackPageEvent (label: string) {
     SMTrackHelper.pageEvent(label);
  }

  setSocialLinks() {
    const optionalService = this.props.optionalService;
    // mail
    const campaign = "optional_service-" + optionalService.id;
    let url = "https://" + location.host + Routes.pages_optional_service_path(optionalService, {
      utm_campaign: campaign,
      utm_source: "email",
      utm_medium: "share",
    });
    const subject = optionalService.title;
    const br = "%0d%0a";
    const body = sprintf(optionalService.description + "%s%s",
      br + br,
      encodeURIComponent(url)
    );
    const mailUrl = sprintf("mailto:?subject=%s&body=%s", subject, body);

    // facebook
    const prefix = location.pathname.length && location.pathname[0] == "?" ? "&" : "?";
    url = location.href + sprintf("%sutm_optional_service=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "facebook", "share"
    );
    const fbUrl = sprintf("https://www.facebook.com/sharer/sharer.php?u=%s&amp;t=%s",
      encodeURIComponent(url), subject
    );

    // line
    url = location.href + sprintf("%sutm_optional_service=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "line", "share"
    );
    const lineUrl = sprintf("https://line.me/R/msg/text/?%s",
      encodeURIComponent(subject + " " + url),
    );
    this.setState({
      mailUrl: mailUrl,
      fbUrl: fbUrl,
      lineUrl: lineUrl,
    });
  }

  favoriteDidSelect(rowIndex: number, e: SyntheticEvent) {
    e.preventDefault();

    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    const isFavorite = $(e.currentTarget).hasClass("units-item-fav__on");
    const room = this.state.rooms[rowIndex];

    if (isFavorite) {
      // お気に入りに登録されている場合はモーダルを表示させる
      this.showFavoriteListSelectForm(room, e);
    } else {
      let responseHandler = (data, error, xhr) => {
        let rooms = this.state.rooms;

        if (error) {
          room.is_favorite = false;
          rooms[rowIndex] = room;
          this.setState({
            rooms: rooms,
          });

        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          rooms[rowIndex] = room;
          this.setState({
            rooms: rooms,
            targetFavoriteRoom: room,
            latestUpdatedFavoriteList: data.favorite_list,
            isOpenDefaultFavoriteList: true,
          });
          setTimeout(() => {
            this.setState({
              isOpenDefaultFavoriteList: false,
            });
          }, 2000);
        }
      };

      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  showFavoriteListSelectForm(room: Object, e: SyntheticEvent){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  formDidSubmit(e: SyntheticEvent) {
    if (!this.state.canRequest) return;
    this.setState({canRequest: false});
    e.preventDefault();

    const formData = new FormData(this.refs.form);
    SMOptionalServiceResource.inquiry(formData, (inquiry, error, xhr) => {
      if (error) {
        this.setState({canRequest: true});
        switch (xhr.status) {
          case 400:
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error) => {
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 500:
            break;
        }
      } else {
        SMAppHelper.redirectTo(Routes.sent_pages_optional_services_path({title: this.props.optionalService.title}));
      }
    });
  }

  renderFormItemError(name: string) {
    const message = this.state.errors[name];
    if (message) {
      return (
        <p className="signup-box__required"><i className="fa fa-exclamation-circle"></i>{message}</p>
      );
    }
    return null;
  }

  renderOptionalServiceInquiryForm() {
    const defaultRows = 6;
    const optionalService = this.props.optionalService;

    const additionalQuestion1Style = optionalService.additional_question_1.length === 0 ? {display: "none"} : {};
    const additionalQuestion2Style = optionalService.additional_question_2.length === 0 ? {display: "none"} : {};
    const additionalQuestion3Style = optionalService.additional_question_3.length === 0 ? {display: "none"} : {};

    return (
      <div className="container">
        <h2 className="campaign-contact__title">お問い合わせ</h2>
        <p className="campaign-contact__text">このサービスへのお申し込み、資料請求などのお問い合わせは下記フォームよりご連絡ください。</p>
        <div className="signup-box campaign-contact__box">
          <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
            <div className="row">

              <div className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100per"
                        id="optional_service_inquiry_name"
                        name="name"
                        label={I18n.t("service.label_000504")}
                        floatingLabel
                      />
                      {this.renderFormItemError("name")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100per"
                        id="optional_service_inquiry_email"
                        name="email"
                        label={I18n.t("service.label_000500")}
                        floatingLabel
                      />
                      {this.renderFormItemError("email")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100per"
                        id="optional_service_inquiry_tel"
                        name="tel"
                        label={I18n.t("service.label_000111")}
                        floatingLabel
                      />
                      {this.renderFormItemError("tel")}
                    </div>
                  </div>
                </div>
              </div>

              <div style={additionalQuestion1Style} className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100per"
                        id="optional_service_inquiry_additional_question_1"
                        name="additional_content_1"
                        label={optionalService.additional_question_1}
                        floatingLabel
                      />
                      {this.renderFormItemError("additional_question_1")}
                    </div>
                  </div>
                </div>
              </div>

              <div style={additionalQuestion2Style} className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100per"
                        id="optional_service_inquiry_additional_question_2"
                        name="additional_content_2"
                        label={optionalService.additional_question_2}
                        floatingLabel
                      />
                      {this.renderFormItemError("additional_question_2")}
                    </div>
                  </div>
                </div>
              </div>

              <div style={additionalQuestion3Style} className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100per"
                        id="optional_service_inquiry_additional_question_3"
                        name="additional_content_3"
                        label={optionalService.additional_question_3}
                        floatingLabel
                      />
                      {this.renderFormItemError("additional_question_3")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="signup-box__wrapper-form">
                  <div className="row signup-box__md-top">
                    <div className="col-sm-12">
                      <Textfield
                        className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100per"
                        id="optional_service_inquiry_content"
                        name="content"
                        label={I18n.t("service.label_000112")}
                        rows={defaultRows}
                        floatingLabel
                      />
                      {this.renderFormItemError("content")}
                    </div>

                    <div className="col-sm-12 ta-c">
                      <input type="submit" name="commit" value="送信する" className="button-blue mt20 pt15 pb15 w300 sm-w100" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input type="hidden" name="optional_service_id" value={optionalService.id} />
          </form>
        </div>
      </div>
    );
  }

  render() {
    const optionalService = this.props.optionalService;
    const rooms = this.state.rooms;
    const benefitDate = sprintf("有効期限：%s〜%s", moment(optionalService.benefit_valid_at).format("YYYY年M月D日"), moment(optionalService.benefit_expires_at).format("YYYY年M月D日"));
    const moreUrl = optionalService.search_query || Routes.search_index_path();
    const backgroundImage = optionalService.benefit_background_image == null ? 'none' : sprintf('url(%s)', optionalService.benefit_background_image);

    const roomListStyle = optionalService.search_title.length == 0 && optionalService.search_query.length == 0 ? {display: "none"} : {};
    const benefitDateStyle = optionalService.benefit_valid_at == null && optionalService.benefit_expires_at == null ? {display: "none"} : {};
    const isValidStyle = optionalService.is_valid ? {} : {display: "none"};
    const noteStyle = optionalService.notes.length !== 0 ? {} : {display: "none"};

    return (
      <div className="site-main">
        <div className="page__odd campaign__padding">
          <div className="campaign__heroimg">
            <OptimizedImage
              src={SMFormatHelper.imageURLWithTransform(optionalService.image, {width: 1200, height: 630})}
              alt={sprintf("%s の写真", optionalService.title)}
              className="campaign__img"
            />
          </div>
          <div className="container">
            <h1 className="campaign-about__title">{optionalService.title}</h1>
            <h2 className="campaign-about__heading" dangerouslySetInnerHTML={{__html: SMFormatHelper.nl2br(optionalService.description)}}></h2>
            <ul className="row campaign-about__social">
              <li className="col-xs-4">
                <a href={this.state.mailUrl} className=" social-link__mail"><i className="fa fa-envelope"></i></a>
              </li>
              <li className="col-xs-4">
                <a href={this.state.lineUrl} target="_blank" className="social-link__line"><i className="icon-spm-line"></i></a>
              </li>
              <li className="col-xs-4">
                <a href={this.state.fbUrl} className="social-link__facebook"><i className="fa fa-facebook-square"></i></a>
              </li>
            </ul>
            {(()=>{
              if (optionalService.is_valid) return null;
              return (
                <div className="campaign-about__closed">このサービスは終了しました。</div>
              );
            })()}
            <div className="campaign-about__border">
              {
                optionalService.articles.map((article, rowIndex) => {
                  return(
                    <div key={`article_${rowIndex}`} className="row campaign-about__casette">
                      <div className="col-sm-3">
                        <a href="#" target="_blank">
                          <OptimizedImage
                            src={SMFormatHelper.imageURLWithTransform(article.image, {width: 680, height: 510})}
                            alt={sprintf("%s の写真", article.content)}
                            className="w100pa"
                          />
                        </a>
                      </div>
                      <div className="col-sm-9">
                        <p className="campaign-about__discription" dangerouslySetInnerHTML={{__html: SMFormatHelper.nl2br(article.content)}}></p>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>

        <div className="page__odd campaign-coupon campaign__padding" style={{backgroundColor: optionalService.benefit_background_color, backgroundImage: backgroundImage}} >
          <div className="campaign-coupon__inner">
            {
              optionalService.benefit_tags.map((tag, rowIndex) => {
                return (<div key={`tag_${rowIndex}`} className="campaign-coupon__points"><p className="campaign-coupon__points-inner">{tag}</p></div>);
              })
            }
            <h2 className="campaign-coupon__name">{optionalService.benefit_title}</h2>
            <p className="campaign-coupon__date" style={benefitDateStyle}>{benefitDate}</p>
            <p className="campaign-coupon__feature" dangerouslySetInnerHTML={{__html: SMFormatHelper.nl2br(optionalService.benefit_description)}}></p>
          </div>
        </div>

        <div className="page__odd campaign__padding" style={roomListStyle}>
          <div className="container">
            <h2 className="campaign-target__title">{optionalService.search_title}</h2>
            <div className="row">
              {
                rooms.map((room, rowIndex) => {
                  const favClassName = room.is_favorite ? "units-item-fav__on extra-units__item-fav units-item-fav__click" : "units-item-fav extra-units__item-fav";
                  const latestUpdatedFavoriteListPopup = [];
                  if (this.state.isOpenDefaultFavoriteList && room == this.state.targetFavoriteRoom && Object.keys(this.state.latestUpdatedFavoriteList).length !== 0) {
                    latestUpdatedFavoriteListPopup.push(
                      <div className="units-item__baloon-s">
                        <p className="units-item__baloon-text">{this.state.latestUpdatedFavoriteList.name}</p>
                      </div>
                    );
                  }
                  return(
                    <div key={`room_${room.id}`} className="col-sm-12 col-md-3">
                      <a href={Routes.space_room_path(room.space.username, room.uid)} onClick={this.trackPageEvent.bind(this, `optionalService_${optionalService.id} select room_${room.uid}`)} className="a__extra-units">
                        <div className="extra-units">
                          <div className="extra-units__image">
                            <OptimizedImage
                              src={SMFormatHelper.imageURLWithTransform(room.thumbnails[0].image, {width: 490, height: 490})}
                              alt={sprintf("%s の写真", room.name)}
                              className="extra-units__image-pict"
                            />
                            <p className="extra-units__item-price">{room.min_price_text}<span className="extra-units__item-per">{SMFormatHelper.priceUnit(room.min_price_unit_text, true)}</span>
                              {
                                (() => {
                                  if (room.has_direct_reservation_plans) {
                                    return <i className="fa fa-bolt icon-direct"></i>;
                                  }
                                })()
                              }
                              {
                                (() => {
                                  if (room.owner.rank && room.owner.rank == SMConst.OwnerRank.SuperHost) {
                                    return <img src={SMRailsBridge.assetPath.goldSuperHost} className="extra-units__item-super-host" />;
                                  }
                                })()
                              }
                            </p>
                          </div>
                          <div className="extra-units__body">
                            <div className="extra-units__body-inner link__subcolor">
                              <h3 className="extra-units__body-title">{SMFormatHelper.roomName(room)}</h3>
                            </div>
                              <p className="extra-units__body-access">{room.space.access}</p>
                          </div>
                        </div>
                      </a>
                      <a href="#" onClick={this.favoriteDidSelect.bind(this, rowIndex)} aria-label="favorite" className={favClassName}><i className="fa fa-heart"></i></a>
                      <CSSTransitionGroup transitionName="js-favoritelist-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                        {latestUpdatedFavoriteListPopup}
                      </CSSTransitionGroup>
                    </div>
                  );
                })
              }
            </div>
            <div className="mod-more__area">
              <a href={moreUrl} className="button-blue mod-more__area-button">サービス対象スペースをすべて見る</a>
            </div>
          </div>
        </div>

        <div style={isValidStyle}>
          <div className="page__even campaign__padding">
            {this.renderOptionalServiceInquiryForm()}
          </div>

          <div className="page__odd campaign__padding" id="campaign-attention" style={noteStyle}>
            <div className="container">
              <h2 className="campaign-attention__title">サービス利用上の注意</h2>
              <ul className="campaign-attention__list">
                <span dangerouslySetInnerHTML={{__html: optionalService.notes}}></span>
              </ul>
            </div>
          </div>
        </div>
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />

      </div>
    );
  }
}
export default SMOptionalServiceView;



// WEBPACK FOOTER //
// ./app/javascript/components/optional_services/SMOptionalServiceView.jsx